import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { MatRippleModule } from './ripple-module.mjs';
import { MatPseudoCheckboxModule } from './pseudo-checkbox-module.mjs';
import { MatCommonModule } from './common-module.mjs';
import { MatOption, MatOptgroup } from './option.mjs';
let MatOptionModule = /*#__PURE__*/(() => {
  class MatOptionModule {
    static ɵfac = function MatOptionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatOptionModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatOptionModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MatRippleModule, MatCommonModule, MatPseudoCheckboxModule, MatOption]
    });
  }
  return MatOptionModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MatOptionModule };
